module.exports = __webpack_public_path__ + "static/media/LearnCreatorHowItWorks5.ae31f707.png";